import { mapGetters } from "vuex";
import * as types from "@/store/types";
const Rial = () => import("@/components/OperationsPage/Deposit/Rial/index");
const Crypto = () => import("@/components/OperationsPage/Deposit/Crypto/index");
export default {
  name: "deposit",
  components: { Rial, Crypto },
  props: [],
  data() {
    return {
      tab: 1,
      fromQueryIso: "",
      noFromQueryIso: "",
      paymentType: "online",
      isVerified: true
    };
  },
  computed: {
    ...mapGetters({
      QueryIsoGetter: types.operations.getters.GET_OPERATION_QUERY_ISO,
      getDepositCurrencies: types.operations.getters.GET_DEPOSIT_CURRENCIES,
      getUserInfo: types.userInfo.getters.GET_USER_INFO
    }),
    isVerify() {
      return !!this.getUserInfo.actions?.deposit_rial?.is_active;
    },
    getQuery() {
      if (this.QueryIsoGetter) {
        return this.QueryIsoGetter;
      }
    },
    getFirstCurrencyFromWallet() {
      if (Object.entries(this.getDepositCurrencies).length !== 0) {
        return this.getDepositCurrencies[0];
      }
    },
    filteredRouteQueryTypes() {
      if (this.getUserInfo.is_global) {
        return this.$t("operationsPage.routeQueryTypes").filter(
          item => item.query !== "IRR"
        );
      }
      return this.$t("operationsPage.routeQueryTypes");
    }
  },
  mounted() {
    if (this.$route.query.from === "IRR") {
      this.tab = 0;
    }
    if (this.$route.query.paymentType) {
      this.paymentType = this.$route.query.paymentType;
    }
  },
  watch: {
    getQuery: {
      immediate: true,
      handler(newValue) {
        this.fromQueryIso = newValue;
      }
    },
    getFirstCurrencyFromWallet: {
      immediate: true,
      handler(newValue) {
        if (newValue) {
          this.noFromQueryIso = newValue.currency.iso;
        }
      }
    }
  },
  methods: {
    addQueryParameters(dataQuery) {
      if (dataQuery === "IRR") {
        this.$router.push({
          query: { from: dataQuery, paymentType: this.paymentType }
        });
      } else {
        if (this.fromQueryIso && this.fromQueryIso !== "IRR") {
          this.$router.push({
            query: { from: this.fromQueryIso }
          });
        } else {
          this.$router.push({
            query: { from: this.noFromQueryIso }
          });
        }
      }
    }
  }
};
